import Vue from "vue";
import util from "../../util";
import vdialogComponent from "./vdialog.vue";

let instance;
let vdialogConstructor = Vue.extend(vdialogComponent); //将组件变成实例

let initInstance = () => {
  instance = new vdialogConstructor({ //相当于 new Vue, 组件的new Vue
    el: document.createElement('div')
  })
  document.body.appendChild(instance.$el);
}

let vdialog = (option = {}) => {
  initInstance();
  util.merge(instance.$data, option);
  return new Promise((resolve, reject) => {
    instance.show = true;
    let success = instance.success;
    let cancel = instance.cancel;

    instance.success = () => {
      let type = instance.type
      let inputs = instance.inputs
      success();
      if (type === 'input') {
        resolve(inputs);
      } else {
        resolve('ok')
      }
    }
    instance.cancel = () => {
      cancel();
      resolve('cancel');
    }
  });
}

const install = function (Vue) {
  Vue.component(vdialog.name, vdialog); //注册为全局组件
  Vue.prototype.$vdialog = vdialog; //变为全局方法
}
export default install;
